/**
 * @generated SignedSource<<43b0e0dfbc8985bd4d8871865874122d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type blockedIssue_periscope_BlockedIssuesPanel$data = {
  readonly assignee: {
    readonly name: string | null | undefined;
    readonly pictureUrl: string | null | undefined;
  } | null | undefined;
  readonly issueIconUrl: string | null | undefined;
  readonly issueKey: string;
  readonly priority: {
    readonly iconUrl: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly storyPoints: number | null | undefined;
  readonly title: string;
  readonly " $fragmentType": "blockedIssue_periscope_BlockedIssuesPanel";
};
export type blockedIssue_periscope_BlockedIssuesPanel$key = {
  readonly " $data"?: blockedIssue_periscope_BlockedIssuesPanel$data;
  readonly " $fragmentSpreads": FragmentRefs<"blockedIssue_periscope_BlockedIssuesPanel">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "blockedIssue_periscope_BlockedIssuesPanel",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "issueKey"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "storyPoints"
    },
    {
      "kind": "ScalarField",
      "name": "issueIconUrl"
    },
    {
      "concreteType": "WorkSuggestionsJiraAssignee",
      "kind": "LinkedField",
      "name": "assignee",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "pictureUrl"
        }
      ]
    },
    {
      "concreteType": "WorkSuggestionsJiraPriority",
      "kind": "LinkedField",
      "name": "priority",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        },
        (v0/*: any*/)
      ]
    }
  ],
  "type": "WorkSuggestionsBlockedIssue"
};
})();

(node as any).hash = "519f40516c0dc95d2e68b17b5fb1c812";

export default node;
